import {ContentType, GetFormData, Global, Header, http, Method} from './api-util';
import AuthUtil from "@/utils/AuthUtil";
import userStore from '@/store-mobx/user/user-store'

/**
 * 登录
 * @param {*} param0
 */
export const login = async ({username, password}) => {
    await http({
        method: Method.POST,
        url: Global.BASE_URL + '/api/user/login',
        data: {
            username,
            password
        }
    });
    AuthUtil.setToken("token")
    userStore.loadData()
};

/**
 * 退出登录
 */
export const logout = async () => {
    await http({
        method: Method.GET,
        url: Global.BASE_URL + '/api/user/logout'
    });
    AuthUtil.removeAuth()
    userStore.loadData()
};

/**
 * 注册
 * @param {*} param0
 */
export const register = async (
    {
        username,
        password,
        avatar,
        nickname,
        gender,
        birthday
    }
) => {
    const formData = GetFormData({
        username,
        password,
        avatarFile: avatar,
        nickname,
        gender,
        birthday
    });

    await http({
        method: Method.POST,
        url: Global.BASE_URL + '/api/user/register',
        headers: {
            [Header.ContentType]: ContentType.FormData
        },
        data: formData
    });

    AuthUtil.setToken("token")
    userStore.loadData()
};
